var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',_vm._b({attrs:{"alt":_vm.alt,"disabled":_vm.disabled,"href":_vm.href,"ripple":false,"title":_vm.title,"to":_vm.to,"link":"","plain":"","text":""},on:{"click":function($event){return _vm.$emit('click', $event)}}},'v-btn',_vm.$props,false),[_vm._v(" "+_vm._s(_vm.label)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }